export default __webpack_public_path__ + "static/media/m_diagram1_eng.023b5224.png";